import { Cart, DiscountCodeState } from "src/types/ctgraphql.d";
import { isShippingPriceFree } from "src/utils/ct/shippingMethodPrice";

const SHIPPING_DISCOUNT_TARGET = "shipping";

export const hasFreeShippingDiscountCode = (cart?: Cart | null): boolean =>
  Boolean(
    cart?.discountCodes?.some(
      ({ state, discountCode }) =>
        state === DiscountCodeState.MatchesCart &&
        discountCode?.cartDiscounts?.some(
          ({ target }) => target?.type === SHIPPING_DISCOUNT_TARGET
        )
    )
  );

export const cartHasFreeShipping = (cart?: Cart | null): boolean => {
  if (!cart) {
    return false;
  }

  if (cart.shippingInfo) {
    return isShippingPriceFree(cart);
  }

  return hasFreeShippingDiscountCode(cart);
};
